export default __webpack_public_path__ + "static/media/helpFieldIcon.3fb6a2ab.svg";